<template>
 <b-container>
  <b-form-input
    id="filter-input"
    v-model="filter"
    type="search"
    placeholder="Type to Search"
  ></b-form-input>

  <b-table striped hover 
    :items="users" 
    :fields="fields"
    :busy="loading"
    :filter="filter" 
    :filter-included-fields="filterFields"  
    :sort-by.sync="sortBy"
    :sort-direction="sortDirection"
    show-empty>
    <template #table-busy>
      <div class="text-center my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Loading...</strong>
      </div>
    </template>

    <template v-slot:empty>
      <b-container fluid>
        <b-row>
          <b-col cols="12" md="4" class="mx-auto">
            <h4 class="text-center">You have no users yet.</h4>
          </b-col>
        </b-row>
      </b-container>
    </template>
    
    <template v-slot:cell(actions)="data">
      <b-container fluid>
        <b-row>
          <b-col>
            <b-button
              v-if="!data.item.disabled"
              variant="danger" 
              title="Disable User"
              block
              @click="disableUser(data.item.uid)"
            >
              <b-icon-slash-circle />&nbsp;
              <span class="d-none d-lg-inline">Disable</span>
            </b-button>
            <b-button
              v-else
              variant="primary"
              title="Enable User"
              block
              @click="enableUser(data.item.uid)"
            >
              <b-icon-person-check />&nbsp;
              <span class="d-none d-lg-inline">Enable</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-table>       
 </b-container>
</template>
<script>
import moment from 'moment';
import Users from '@/fstore/collections/User'
export default {
  name: 'Users',
  data() {
    return {
      users: [],
      currentPage: 1,
      perPage: 25,
      perPageOptions: [5, 10, 25, 50, 100],
      sortBy: 'created',
      sortDirection: 'asc',
      filter: null,
      filterFields: [
        'created',
        'fname',
        'lname',
        'email',
        'role'
      ],
      loading: false,
        fields: [
          {
            key: 'created',
            sortable: true,
            formatter: (value, key, item) => {
              let d = moment(value);
              if(!d.isValid())
                d = moment(value.toDate());

              return d.format('MMM. Do, YYYY');
            }
          },
          {
            key: 'fname',
            sortable: true,
          },
          {
            key: 'lname',
            sortable: true,
          },
          {
            key: "email",
            sortable: true,
          },
          {
            key: "role",
            sortable: true,
          },
          "actions"
        ],
    }
  },
  async mounted(){
    await this.getUsers();
  },
  methods:{
    async getUsers(){
      this.users = await Users.getAllUsers();
    },
    async disableUser(userId){
      this.$store.dispatch('app/setOverlay', true, {root: true});
      await Users.update(userId, {disabled: true});
      await this.getUsers();
      this.$store.dispatch('app/setOverlay', false, {root: true});
    },
    async enableUser(userId){
      this.$store.dispatch('app/setOverlay', true, {root: true});
      await Users.update(userId, {disabled: false});
      await this.getUsers();
      this.$store.dispatch('app/setOverlay', false, {root: true});
    }
  }
}
</script>